import React from 'react';
import { Box, Container, Paper, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MainLayout from '../../../../../../components/Layout/MainLayout';

const PaymentSuccess: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate('/imigra-pulse-canada/painel');
    window.scrollTo(0, 0);
  };

  return (
    <MainLayout>
      <Container maxWidth="sm" sx={{ mt: 8, mb: 8 }}>
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <CheckCircleIcon color="success" sx={{ fontSize: 64 }} />
          </Box>
          <Typography variant="h5" sx={{ mb: 1 }}>
            {t('payment_success_title')}
          </Typography>
          <Typography variant="body1" sx={{ mb: 4 }}>
            {t('payment_success_message')}
          </Typography>
          <Button variant="contained" onClick={handleGoToDashboard}>
            {t('payment_success_button_back_to_dashboard')}
          </Button>
        </Paper>
      </Container>
    </MainLayout>
  );
};

export default PaymentSuccess;

